import { render } from "./OneExam.vue?vue&type=template&id=36905ba0"
import script from "./OneExam.vue?vue&type=script&lang=js"
export * from "./OneExam.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__